import {isFeatureEnabled} from 'feature-flags';

import {isNil} from 'ramda';

import {useGetUserDashboardSettingsQuery} from '@dms/api/customer';
import {featureFlags} from '@dms/feature-flags';

import {WORKSHOP_OVERVIEW_TILES} from '../components/WorkshopOverview/constants/workshopOverviewTiles';

// With dashboard customisation on, the arrangement alone decides whether the workshop overview
// shows, so its per-section settings no longer narrow what the tile renders.
export function useDashboardWidgetSettings() {
  const {data: settings} = useGetUserDashboardSettingsQuery();

  if (isNil(settings) || !isFeatureEnabled(featureFlags.DASHBOARD_CUSTOMISATION)) {
    return settings;
  }

  return WORKSHOP_OVERVIEW_TILES.reduce(
    (widgetSettings, tile) => ({...widgetSettings, [tile.settingsKey]: true}),
    settings
  );
}
